<template>
  <hover-tooltip v-if="tooltip" :tooltip-style="tooltipStyle || undefined">
    <v-chip
      :color="resolvedColor"
      small
      class="white--text rmr-status-chip"
      :class="[`rmr-status-chip--${size}`, { 'rmr-status-chip--fixed': fixed }]"
    >
      {{ label }}
    </v-chip>
    <template slot="tooltip">{{ tooltip }}</template>
  </hover-tooltip>
  <v-chip
    v-else
    :color="resolvedColor"
    small
    class="white--text rmr-status-chip"
    :class="[`rmr-status-chip--${size}`, { 'rmr-status-chip--fixed': fixed }]"
  >
    {{ label }}
  </v-chip>
</template>

<script>
import HoverTooltip from "@/components/common/HoverTooltip.vue";
import {
  RMR_DANGER,
  RMR_INFO,
  RMR_INDIGO,
  RMR_ORANGE,
  RMR_SUCCESS,
  RMR_TEXT_SUBTLE,
} from "@/styles/tokens";

const STATUS_CHIP_VARIANT_COLORS = {
  primary: RMR_INDIGO,
  success: RMR_SUCCESS,
  info: RMR_INFO,
  error: RMR_DANGER,
  warning: RMR_ORANGE,
  neutral: RMR_TEXT_SUBTLE,
  completed: RMR_SUCCESS,
  running: RMR_INFO,
  failed: RMR_DANGER,
  to_relaunch: RMR_ORANGE,
  pending: RMR_TEXT_SUBTLE,
};

export default {
  name: "RmrStatusChip",
  components: { HoverTooltip },
  props: {
    label: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: "",
    },
    variant: {
      type: String,
      default: "",
    },
    tooltip: {
      type: String,
      default: "",
    },
    tooltipStyle: {
      type: Object,
      default: null,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "md",
      validator: (value) => ["sm", "md"].includes(value),
    },
  },
  computed: {
    resolvedColor() {
      if (this.variant) {
        return STATUS_CHIP_VARIANT_COLORS[this.variant] || this.variant;
      }
      return this.color;
    },
  },
};
</script>

<style lang="scss" scoped>
.rmr-status-chip {
  font-weight: 700;
  justify-content: center !important;
  border-radius: $rmr-radius-sm !important;
}

.rmr-status-chip--md {
  min-height: 24px;
  padding: 0 8px;
  font-size: 12px;
  line-height: 1;
}

.rmr-status-chip--sm {
  min-height: 18px;
  padding: 0 6px;
  font-size: 10px;
  line-height: 1;
}

.rmr-status-chip--fixed {
  min-width: 96px;
}
</style>
